import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  DateGrouping,
  ChartType,
  type ChartClickEventArgs,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';
import { useMemo, useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.LineChart.LineChartMainDemo';

export function LineChartMainSample() {
  const t = useT();
  const [lastClick, setLastClick] = useState<ChartClickEventArgs | null>(null);
  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'actualclosedate',
        groupByDateGrouping: DateGrouping.Year,
        aggregateColumn: 'estimatedvalue',
        aggregate: QueryAggregate.Average,
        seriesColumn: 'opportunityratingcode',
        filterXml:
          "<filter><condition attribute='statecode' operator='ne' value='0' /></filter>",
      }),
    [],
  );
  return (
    <>
      <DataverseChart
        dataSource={source}
        type={ChartType.Line}
        title={t(`${STRINGS_BASE}.chart-title`)}
        yAxisPrefix="$"
        onElementClick={setLastClick}
      />
      {lastClick && (
        <p style={{ marginTop: '12px' }}>
          <strong>{t(`${STRINGS_BASE}.clicked-label`)}:</strong>{' '}
          {lastClick.datasetLabel} — {lastClick.label} — ${lastClick.value.toLocaleString()}
        </p>
      )}
    </>
  );
}
